import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../provider/AuthProvider";

// Used as a layout route (element + nested children in the route config),
// so it must render <Outlet/> — props.children is always undefined there.
export const SuperAdminRoute = ({ children }) => {
  const { token, userdetails, isAuthLoading } = useAuth();
  if (isAuthLoading) return null;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!userdetails?.is_superuser) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children ?? <Outlet />;
};